package com.devi3east.bashbuddy.features.events.detail.ui

import com.devi3east.bashbuddy.features.events.common.data.models.Event
import com.devi3east.bashbuddy.features.events.common.data.models.Ticket
import com.devi3east.bashbuddy.prizeList.domain.models.Prize
import com.devi3east.bashbuddy.account.profile.domain.models.Profile

data class EventDetailUiState(
    val isLoading: Boolean = true,
    val errorMessage: String? = null,
    val profile: Profile? = null,
    val event: Event? = null,
    val isFavorite: Boolean = false,
    val ticketList: List<Ticket>? = emptyList(),
    val prizeList: List<Prize>? = emptyList(),
    val showPurchaseButton: Boolean = false,
    val externalPurchaseUrl: String? = null
)